import { EnergyPassportDetailsTable } from "@/features/energy-passport/ui/detail-tables/energy-passport-details-table.tsx"
import { useEnergyPassportDetailsStore } from "@/features/energy-passport/ui/detail-tables/model/store.ts"

export function EnergyPassportCoalTable() {
  // Store
  const { coal } = useEnergyPassportDetailsStore()
  return <EnergyPassportDetailsTable title="Энергетических баланс угля" storeItem={coal} />
}
